import React, {PureComponent} from 'react';
import {connect} from 'react-redux';
import PropTypes from 'prop-types';
import $ from 'jquery';
import {FormattedMessage, injectIntl} from "react-intl";

import OnScreenKeyboard from '../../../common/OnScreenKeyboard/keyboard';
import { browserIsSafari } from '../../../../misc/helpers';
import Analytics from './../../../../analytics';

class FiltersSearch extends PureComponent {
  static propTypes = {
    searchText: PropTypes.string.isRequired,
    handleSearchInputChange: PropTypes.func.isRequired,
  };

  constructor(props) {
    super(props);
    this.state = {
      searchVisible: false,
    };
  }

  handleToggleSearch = () => {
    Analytics.sendClickEvent('filter-search-' + (this.state.searchVisible ? 'hide' : 'show'));
    this.setState({searchVisible: !this.state.searchVisible}, () => this.state.searchVisible && $(this.searchInputNode).focus());
  };

  handleInputSearchFocus = () => {
    if (this.props.windowWidth < 991 && browserIsSafari()) { // scroll to the top of the window on mobile (Safari workarounds)
      window.scrollTo(0, 0);
      setTimeout(() => {
        window.scrollTo(0, 0);
      }, 0);
      setTimeout(() => {
        window.scrollTo(0, 0);
      }, 300)
    }
  };

  render() {
    const {intl} = this.props;
    return (
      <div className={"filters-header-icon filters-header-icon--search"}
           onClick={() => this.handleToggleSearch()}>
        <FormattedMessage id={"filterSelection.searchPlaceholder"}/>
        <div
          className={"filters-header-input" + (this.state.searchVisible ? " filters-header-input--visible": "")}
          onClick={(e) => e.stopPropagation()}>
          <input type="text" ref={(node) => this.searchInputNode = node}
                 className="filters-header-input-search"
                 placeholder={intl.formatMessage({id: "filterSelection.searchPlaceholder"})}
                 value={this.props.searchText}
                 onFocus={this.handleInputSearchFocus}
                 onChange={this.props.handleSearchInputChange}
                 onClick={(e) => e.stopPropagation()}
                 id="filter-search"
          />
          <OnScreenKeyboard inputId="filter-search"
                            setValue={(v) => this.props.handleSearchInputChange({target: {value: v}})}
                            type="text"
                            prependTo=".filters-container"
                            top="40px"
                            left="10px"
          />
        </div>
      </div>
    )
  }
}

const mapStateToProps = (store) => {
  return {
    windowWidth: store.serverState.windowWidth,
  };
};

const mapDispatchToProps = {

};
export default injectIntl(
  connect(mapStateToProps, mapDispatchToProps)(FiltersSearch)
)
